import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import { vuexfireMutations, firestoreAction, firebaseAction} from 'vuexfire'
import firebase from 'firebase/app';
import 'firebase/auth';
@Module({ namespaced: true })
class User extends VuexModule {
  public loggedIn = false;
  public claims = {};
  public id : string | null = "";
  public name : string | null = "";
  public email : string | null = "";
  public items = [];

  get nameUpperCase(): string {
    if (this.name) {
      return this.name.toUpperCase();
    }
    return "";
  }

  get initials(): string {
    if (this.name) {
      const initials = this.name.match(/\b\w/g) || [];
      return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    }
    return "";
  }

  @Mutation
  public setName(newName: string): void {
    this.name = newName;
  }
  @Mutation
  public login(user: firebase.User): void {
    if (user) {
      this.id = user.uid;
      this.name = user.displayName;
      this.email = user.email;
      this.loggedIn = true;
      const currentUser = firebase.auth().currentUser;
      if (currentUser) {
        currentUser.getIdTokenResult()
          .then(tokenResult => {
            this.claims = tokenResult.claims;
          });
      }
    } else {
      this.name = "";
      this.email = "";
      this.loggedIn = false;
    }
  }
  @Action
  public updateName(newName: string): void {
    this.context.commit("setName", newName);
  }

  @Action
  public updateUser(user: User) {
    this.context.commit("login", user);
  }

  @Action
  public setTodosRef() {
    return firebaseAction(({ bindFirebaseRef }, ref) => {
      bindFirebaseRef('items', ref)
    });
  }
}
export default User;
